import { render } from "./MedicoCreate.vue?vue&type=template&id=2eabb6bc&scoped=true"
import script from "./MedicoCreate.vue?vue&type=script&lang=js"
export * from "./MedicoCreate.vue?vue&type=script&lang=js"

import "./MedicoCreate.vue?vue&type=style&index=0&id=2eabb6bc&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2eabb6bc"]])

export default __exports__